<template>
  <div>
    <template v-if="!isApp">
      <WebView />
    </template>
    <template v-else>
      <MobileView />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import WebView from './views/web/web_view.vue'
import MobileView from './views/mobile_view.vue'

import { getId } from '@/stores/token'

const isApp = ref(false)
const idStore = getId()

const detectAppMode = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)

  console.log('📱 Mobile:', isMobile, '| 🏠 Standalone:', isInStandaloneMode)
  isApp.value = true;// isMobile && isInStandaloneMode;
}

onMounted(() => {
  detectAppMode()
  idStore.initUserFromCookie()

  const lastState = window.localStorage.getItem('lastState')
  if (lastState !== String(isApp.value)) {
    window.localStorage.setItem('lastState', String(isApp.value))
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }
})
</script>

<style>
html, body {
  font-family: 'Ubuntu', sans-serif;
  overflow: hidden;
  height: 100%;
  touch-action: none;
  margin: 0;
  padding: 0;
}

.scrollable {
  overflow-y: auto;
  max-height: 100vh;
  -webkit-overflow-scrolling: touch;
}

* {
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
}

</style>